export const FontFamily = {
    SharpSansMedium: '"sharp-sans-medium", "fallback-font", Arial, sans-serif',
    SharpSansSemibold:
        '"sharp-sans-semibold", "fallback-font", Arial, sans-serif',
    SharpSansBold: '"sharp-sans-bold", "fallback-font", Arial, sans-serif',
};
